export default __webpack_public_path__ + "static/media/Czech.fe5a876e.svg";